// General errors
export var ERROR_INVALID_REQUEST = 4051; // Signup Errors

export var ERROR_SIGNUP_EXISTING_EMAIL = 4034;
export var ERROR_SIGNUP_FB_EXISTING_ACCOUNT = 4033;
export var ERROR_SIGNUP_FB_MISSING_EMAIL = 40331; // Authentication Errors

export var ERROR_PASSWORD_RESET_REQUIRED = 4030;
export var ERROR_INVALID_CREDENTIALS = 4031;
export var ERROR_INVALID_PASSWORD_RESET_TOKEN = 4037;
export var ERROR_PASSWORD_MUST_BE_UNIQUE = 4043;
export var ERROR_CURRENT_PASSWORD_INVALID = 4045; // Payment Errors

export var ERROR_PAYMENT = 4301; // Reservation Errors

export var ERROR_RESERVATION_NO_SPOTS = 5011;
export var ERROR_RESERVATION_WINDOW_CLOSED = 5421; // Gift Code Errors

export var ERROR_INVALID_GIFT_CODE = 4350;